<template>
<section class="drawer drawer-wrapper" :class="{opened:opened}">
  <section class="drawer-close-btn" @click="onClose">
    <i class="fa fa-chevron-right arrow" aria-hidden="true"></i>
  </section>
  <section ref="content" class="drawer-content">
    <header class="drawer-content-header">
      <section class="drawer-content-header-inner">
        <slot name="header" />
      </section>

      <section class="drawer-content-header-toolbar">
        <slot name="toolbar" />
      </section>
    </header>
    <section class="drawer-content-body">
      <slot name="body" />
    </section>
    <footer class="drawer-content-footer">
      <slot name="footer" />
    </footer>
  </section>
</section>
</template>

<script>
import * as EventKeyMap from './EventKeys'

export default {
  name: 'Drawer',
  props: {
    opened: Boolean
  },
  methods: {
    /**
     * 设置显示状态
     * @param flag  状态
     */
    setOpened (flag) {
      this.$emit('update:opened', flag)
      this.$emit('close')
    },
    // 获取内容组件
    getRefContent () {
      return this.$refs.content
    },
    /**
     * 根据页面点击的区域, 判断是否需要隐藏当前组件
     * @param event 点击事件的详情
     */
    onClose (event) {
      if (!event || !this.opened) {
        return
      }

      let refContent = this.getRefContent()

      if (!refContent) {
        return
      }

      let target = event.target

      // 如果当前点击的区域不在内容区域中, 则隐藏当前组件
      if (!refContent.contains(target)) {
        this.setOpened(false)
      }
    }
  },
  created () {
    this.$eventBus.on(EventKeyMap.WRAPPER_CLICK, this.onClose)
  },
  beforeDestroy () {
    this.$eventBus.off(EventKeyMap.WRAPPER_CLICK, this.onClose)
  }
}
</script>

<style lang="scss" scoped>
$HEADER-TOP: 78px;

.drawer-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  min-width: 58.75rem;
  height: 100%;
  padding: $HEADER-TOP 0 0 1em;
  background-color: #ffffff;
  transform: translate(100%, 0%);
  transition: all .333s ease;
  z-index: 11;

  &.opened {
    transform: translate(0%, 0%);
    box-shadow: -2px 0 20px 0 rgba(0, 0, 0, .2);
  }

  .drawer-close-btn {
    position: absolute;
    top: $HEADER-TOP;
    bottom: 0;
    left: 0;
    width: 1em;
    color: rgba(140,146,164,.5);
    background: inherit;
    z-index: 1;
    cursor: pointer;

    &:hover {
      color: #8c92a4;
      background: #fbfbfb;
    }

    .arrow {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 1em;
      height: 1em;
      margin: auto;
      text-align: center;
    }
  }

  .drawer-content {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 3.125em 0 3.9em .5em;
  }

  .drawer-content-header {
    position: absolute;
    top: 0;
    right: 1em;
    left: .5em;
    padding: .6875em 0;
    line-height: 1.5555555555555556;
    box-shadow: inset 0 -1px 0 0 rgba(222, 222, 223, .5);
  }

  .drawer-content-header-toolbar {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    height: 1.75em;
    line-height: 0;
    margin: auto 0;
  }

  .drawer-content-header-inner {
    font: {
      size: 1.125rem;
      weight: bold;
    }
  }

  .drawer-content-body {
    width: 100%;
    height: 100%;
    padding: .45em 1em 0 0;
    overflow: auto;
  }

  .drawer-content-footer {
    position: absolute;
    left: .5em;
    right: 1em;
    bottom: 0;
    height: 2.75em;
    line-height: 2;
    padding: 0 0 .75em 0;

    /deep/ {
      .btn {
        font-size: 1.125rem;
        margin: 0 .4444444444444444em 0 0;
        padding: .4444444444444444em 1.4444444444444444em;
        line-height: 1.2222222222222223;
      }

      .cancel-btn {
        font-size: .875rem;
        padding: 0;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Drawer.vue